import { Component, OnInit } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ConfigService } from '@app-shared/services/config.service';

@Component({
    imports: [SharedModule, RouterModule],
    selector: 'app-access-docs',
    templateUrl: './access-docs.component.html',
    styleUrls: ['./access-docs.component.css']
})
export class AccessDocsComponent implements OnInit {
  apiBaseURL: string;
  // candidateApiBaseURL: string;

  constructor(
    private config: ConfigService
  ) { }

  ngOnInit(): void {
    this.apiBaseURL = this.config.apiBaseURL;
    // this.candidateApiBaseURL = this.config.candidateApiBaseURL;
  }

}
